import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";

export function AuthShell({ title, subtitle, children, image, foot, brand, tagline, panelHeadline }) {
  const [bannerVisible, setBannerVisible] = useState(false);
  useEffect(() => {
    setBannerVisible(localStorage.getItem("barecord_launch_banner") !== "dismissed");
    const onChange = (e) => setBannerVisible(!!e.detail?.visible);
    window.addEventListener("barecord-banner-change", onChange);
    return () => window.removeEventListener("barecord-banner-change", onChange);
  }, []);
  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-black" data-testid="auth-shell" style={bannerVisible ? { paddingTop: "2.5rem" } : undefined}>
      <div className="flex flex-col px-6 sm:px-12 lg:px-20 py-8">
        <Link to="/">{brand || <Logo />}</Link>
        <div className="flex-1 flex flex-col justify-center max-w-md w-full mx-auto py-12">
          <h1 className="font-display text-3xl sm:text-4xl tracking-tight text-paper">{title}</h1>
          <p className="mt-3 text-sm text-fog">{subtitle}</p>
          <div className="mt-9">{children}</div>
          <div className="mt-8 text-sm text-fog">{foot}</div>
        </div>
      </div>
      <div className="relative hidden lg:block overflow-hidden">
        <img src={image} alt="" className="absolute inset-0 w-full h-full object-cover grayscale" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-black/40" />
        {panelHeadline && (
          <div className="absolute top-20 right-12 left-12 text-right" data-testid="panel-headline">
            <p className="font-display text-3xl sm:text-4xl tracking-tight text-paper leading-tight">
              {panelHeadline}
            </p>
          </div>
        )}
        <div className="absolute bottom-12 left-12 right-12">
          <p className="font-display text-2xl tracking-tight text-paper max-w-sm leading-snug">
            {tagline || "Securing the systems that run the world."}
          </p>
        </div>
      </div>
    </div>
  );
}

export function AuthField({ label, testid, ...props }) {
  return (
    <div>
      <label className="text-xs uppercase tracking-widest text-fog">{label}</label>
      <input
        {...props}
        data-testid={testid}
        className="mt-2 w-full bg-transparent border border-white/15 rounded-xl px-4 py-3 text-paper text-sm outline-none focus:border-white/50 transition-colors"
      />
    </div>
  );
}
